import { useInView } from 'react-intersection-observer'

export default useInView
